import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersComponent } from './partners/partners.component';
import { DataModule } from '../data/data.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { GridModule } from '../grid/grid.module';

@NgModule({
  declarations: [
    PartnersComponent
  ],
  imports: [
    CommonModule,
    DataModule,
    GridModule,
    ToolbarModule
  ],
  exports: [
    PartnersComponent
  ]
})
export class PartnersModule { }
